import VChip from './VChip'

export default {
  VChip
}



// WEBPACK FOOTER //
// ./src/components/chips/index.js